import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';

const SiteAssignee = ({
  assigneeList,
  getAssigneeList,
  postAssignee,
  match,
  newAssignee
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    ids: [match.params.id],
    new_assigned_id:'',
    type:1,
    self_assigned:''
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  const [isSiteAssignPending, setIsSiteAssignPending] = useState(false)

  useEffect(() => {
    setSiteId(match.params.id);
    (async () => {
      if (siteId) {
        setIsLoading(true);
        await getAssigneeList(siteId);
        setIsLoading(false);
      }
    })();
  }, [siteId]);

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleModalHide = () => setIsModal(false);

  const handleSubmit = () => {
    const { assigneeDetail } = assigneeData;
    console.log(assigneeDetail)
    if (assigneeDetail === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      const res = newAssignee({
        'new_assigned_id':assigneeDetail?.user_id,
        'ids':[parseInt(match?.params?.id)],
        'type':1,
        self_assigned:assigneeDetail?.self_assigned
      });
      if (res) getAssigneeList(siteId);
    }
  };

  useEffect(() => {
    console.log(assigneeList)
    setIsSiteAssignPending(false)
    if(assigneeList?.current_assignee_data !==undefined  &&
        assigneeList?.current_assignee_data?.change_assignee_status !== undefined
        && parseInt(assigneeList?.current_assignee_data?.change_assignee_status) === 1){
      setIsLoading(true)
      setIsSiteAssignPending(true)
      setIsLoading(false)
    }
  }, [assigneeList])

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.changeAssignee}
      Buttons={isSiteAssignPending ? "" : headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/site-listing`}
    >
      <Assignee
        assigneeList={assigneeList}
        siteId={siteId}
        handleValue={handleAssignee}
        isSiteAssignPending={isSiteAssignPending}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link to={`${baseUrl}/site-listing`} className="btn btn-primary mb-4">
            {localization.goToSiteList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

SiteAssignee.propTypes = {};

export default SiteAssignee;
